<template lang="html">
  <div class="topicPost">
    <ShareHeader :openTarget="'topic/detail?topic_id=' + topicInfo.id" />

    <!-- 话题 -->
    <div class="topicCard">
      <p class="topicTitle">{{topicInfo.topic_name}}</p>
      <div class="topicHot">
        <div class="likeNum">
          <p class="joinNum">{{topicInfo.viewnumber}} <span class="likeText">浏览</span></p>
          <span>·</span>
          <p class="viewNum">{{topicInfo.agreed_number}} <span class="likeText">点赞</span></p>
          <span>·</span>
          <p class="followingNum">{{topicInfo.post_num}} <span class="likeText">评论</span></p>
          <span>·</span>
          <p class="followingNum">{{topicInfo.rewarded_frequency}} <span class="likeText">打赏</span></p>
        </div>
        <p class="originalTab" v-show="topicInfo.original_type == 1">原创</p>
      </div>

      <div class="topicFounder">
        <div class="founderCon">
          <p class="founderHeader">
            <img :src="topicInfo.avatar" alt="">
            <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + topicInfo.uid" />
          </p>
          <p class="founderName">{{topicInfo.username}}</p>
        </div>
        <div class="attentionBtn">
          关注
        </div>
      </div>

      <div class="topicConAll">
        <div id="topicContent" class="topicContent" :class="{'topicContentShow': show}" v-html="topicInfo.supplement"></div>
        <div class="showArticle" v-show="articleBtnShow" @click="articleBtn()">
          <span>阅读全文</span>
          <img :src="`${pagebase}/static/img/emc/all.png`" alt="">
        </div>
      </div>

      <div class="attention" v-show="topicInfo.original_type == 1">
          「本文为作者原创文章，未经授权禁止转载」
        </div>
    </div>

    <!-- 话题贴列表 -->
    <div class="postCon">
      <div class="topicList">
        <div class="singleTopicCon" v-for="(a, index) in postList" :key="index">
          <!-- 无图 -->
          <div class="typeOne" v-if="a.images.length == 0">
            <p class="userHeader">
              <img :src="a.avatar" alt="">
              <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + a.uid" />
            </p>

            <div class="childTopicContent" @click="postMore(a.postid)">
              <p class="userText"> {{a.username}} </p>
              <p class="childTopicText"> {{a.content}} </p>
              <div class="childTopicInfo">
                <p class="childTopicTime">{{a.show_time}}</p>
                <div class="childTopicData">
                  <div>
                    <img src="../../assets/image/icon/browse.png" alt="">
                    <p>{{a.views}}</p>
                  </div>
                  <div>
                    <img src="../../assets/image/icon/reply.png" alt="">
                    <p>{{a.replies}}</p>
                  </div>
                  <div>
                    <img src="../../assets/image/icon/praise.png" alt="">
                    <p>{{a.like_num}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="typeTwo" v-else>
            <p class="userHeader">
              <img :src="a.avatar" alt="">
              <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + a.uid" />
            </p>

            <div class="childTopicContent" @click="postMore(a.postid)">
              <p class="userText"> {{a.username}} </p>
              <div class="childTopicTextElse">
                <p>{{a.content}}</p>
                <img :src="a.images[0]" alt="">
              </div>
              <div class="childTopicInfo">
                <p class="childTopicTime">{{a.show_time}}</p>
                <div class="childTopicData">
                  <div>
                    <img src="../../assets/image/icon/browse.png" alt="">
                    <p>{{a.views}}</p>
                  </div>
                  <div>
                    <img src="../../assets/image/icon/reply.png" alt="">
                    <p>{{a.replies}}</p>
                  </div>
                  <div>
                    <img src="../../assets/image/icon/praise.png" alt="">
                    <p>{{a.like_num}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="topicBtn">
      <div class="partakeBtn">
        <span> 打赏 </span>
        <WxOpenTag ref="wxopentag" :extinfo="'topic/detail?topic_id=' + tid" />
      </div>
      <div class="partakeBtn">
        <span> 点赞 </span>
        <WxOpenTag ref="wxopentag" :extinfo="'topic/detail?topic_id=' + tid" />
      </div>
      <div class="partakeBtnOne">
        <span> 评论 </span>
        <WxOpenTag ref="wxopentag" :extinfo="'topic/detail?topic_id=' + tid" />
      </div>
    </div>

    <div class="callAppIcon" v-show="callApp">
      <img src="../../assets/image/icon/ic_button.png" alt="">
      <WxOpenTag ref="wxopentag" :extinfo="'topic/detail?topic_id=' + topicInfo.id" />
    </div>

    <div class="topIcon" v-show="topPost">
			<img src="../../assets/image/icon/ic_top.png" alt="" @click="getTopBtn">
		</div>
  </div>
</template>

<script>
  import ShareHeader from '@/components/HeadModule';
  import WxOpenTag from '@/components/WxOpenTag';
  import WxShare from '@/utils/wxshare';
  import {pagebase} from '@/utils/http.js';
  
  export default {
    data() {
      return {
        tid: this.$route.query.tid || '',
        topicInfo: [],
        cardShow: 0,
        topicInfoText: '',
        postList: [],
        cur: 0,
        moreBtn: 1,
        commentInfon: [],

        show: false,
        articleBtnShow: true,
        pagebase: pagebase,
        callApp: false,
        topPost: false,
      }
    },
    components: {
      ShareHeader,
      WxOpenTag,
    },
    mounted() {
      this.init();
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('scroll', this.getTopPost);
    },
    methods: {
      init() {
        this.getTopicData();
        this.getPostList();
      },

      // 话题
      getTopicData() {
        this.$http({
          url: '/eleom/topicDetail',
          method: 'get',
          params: {
            topic_id: this.tid,
          },
        }).then(res => {
          if (res.code >= 0) {
            this.topicInfo = res.data;

            new WxShare().share({
              title: this.topicInfo.topic_name,
              desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
              link: window.location.href,
              imgUrl: this.topicInfo.avatar,
            })

            this.txtHeight();
          }
        })
      },

      // 判断文章显示高度
      txtHeight() {
        const targetNode = document.getElementById('topicContent');
        const config = {
          attributes: true,
          childList: true,
          subtree: true
        };

        const callback = function(mutationsList) {
          for (let mutation of mutationsList) {
            if (mutation.target.scrollHeight > 300) {
              this.show = false;
              this.articleBtnShow = true;
            } else {
              this.show = true;
              this.articleBtnShow = false;
            }
          }
        };

        // 创建一个观察器实例并传入回调函数
        const observer = new MutationObserver(callback);

        // 以上述配置开始观察目标节点
        observer.observe(targetNode, config);

        // 之后，可停止观察
        observer.disconnect();
      },
      // 阅读全文按钮
      articleBtn() {
        this.show = true;
        this.articleBtnShow = false;
      },

      // 帖子列表
      getPostList() {
        this.$http({
          url: '/eleom/topicPostList',
          method: 'get',
          params: {
            page: '1',
            topic_id: this.tid,
          },
        }).then(res => {
          if (res.code >= 0) {
            this.postList = res.data;
          }
        })
      },

      // 按钮
      showCard() {
        this.cardShow = 1;
      },
      packUp() {
        this.cardShow = 0;
      },
      postMore(tid) {
        this.moreBtn = 0;
        this.cur = 1;

        this.$router.push({
          path: '/topicPost',
          query: {
            tid: tid,
          }
        })
      },

      // 监听打开app按钮显示隐藏
			handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.callApp = true;
        } else {
          this.callApp = false;
        }
      },

      getTopPost() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.topPost = true;
        } else {
          this.topPost = false;
        }
      },

      // 置顶按钮
      getTopBtn() {
				window.scroll(0, 0);
			},
    },
  }
</script>

<style lang="css" scoped>
  .topicPost {
    box-sizing: border-box;
    padding-bottom: 7.5rem;
    background-color: #F7F8F8;
  }

  .topicCard {
    box-sizing: border-box;
    background-color: #FFFFFF;
    padding: 2rem 1.5rem;
  }

  .topicTitle {
    font-size: 1.8rem;
    color: #1D2023;
    font-weight: 600;
  }

  .topicHot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
  }

  .likeNum {
    display: flex;
    align-items: center;
    margin-top: 1rem;
  }

  .originalTab {
    width: 3.2rem;
    height: 2rem;
    background-color: #FFDAD8;
    border-radius: .3rem;
    color: #F7443F;
    font-size: 1.1rem;
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .followingNum,
  .joinNum,
  .viewNum {
    font-size: 1.2rem;
    color: #555555;
    margin-left: .5rem;
  }

  .likeText {
    margin-right: .5rem;
  }

  .topicFounder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2rem;
  }

  .founderCon {
    display: flex;
    align-items: center;
  }

  .founderHeader {
    position: relative;
  }

  .founderHeader img {
    width: 3.3rem;
    height: 3.3rem;
    border-radius: 50%;
    margin-right: 1rem;
    border: .05rem solid #E5E6EB;
  }

  .founderName {
    font-size: 1.3rem;
    font-weight: 600;
    color: #3F454B;
    margin-right: .2rem;
  }

  .attentionBtn {
    width: 6.4rem;
    height: 2.4rem;
    box-sizing: border-box;
    border: .05rem solid #F7443F;
    border-radius: 1.5rem;
    font-size: 1.2rem;
    color: #F7443F;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .topicConAll {
    position: relative;
    box-sizing: border-box;
    margin-top: 1.4rem;
    border-radius: .8rem;
    font-size: 1.4rem;
    color: #606972;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .topicContent {
    max-height: 34rem;
    overflow: hidden;
    text-align: justify;
  }

  .topicContent>>>img {
    width: 100% !important;
    border-radius: .8rem;
    margin: 1rem 0;
  }

  .topicContentShow {
    max-height: none;
  }

  .showArticle {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5rem;
    background-color: red;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    text-align: center;
    color: #F7443F;
    display: flex;
    align-items: end;
    justify-content: center;
  }

  .showArticle img {
    width: 1.2rem;
    height: 1.2rem;
    padding-bottom: .2rem;
    padding-left: .2rem;
  }

  .attention {
    font-size: 1.3rem;
    color: #F7443F;
    margin-top: 1.5rem;
    text-align: center;
  }

  /* 帖子 */
  .postCon {
    width: 100%;
    margin-top: .8rem;
    background-color: red;
  }

  .singleTopicCon {
    width: 100%;
    box-sizing: border-box;
    padding: 1.6rem 1.5rem;
    background-color: #FFFFFF;
  }

  /* 无图 */
  .typeOne,
  .typeTwo {
    position: relative;
    display: flex;
    width: 100%;
  }

  .userHeader {
    position: relative;
  }

  .userHeader img {
    width: 2.7rem;
    height: 2.7rem;
    border-radius: 50%;
    margin-right: 1rem;
    border: .05rem solid #E5E6EB;
  }

  .childTopicContent {
    width: 100%;
  }

  .userText {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333333;
  }

  .childTopicText {
    font-size: 1.4rem;
    color: #555555;
    margin-top: .6rem;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .childTopicTextElse {
    display: flex;
  }

  .childTopicTextElse p {
    font-size: 1.4rem;
    color: #555555;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    width: 18.7rem;
    line-height: 2.3rem;
    margin-top: .4rem;
    margin-right: 1rem;
  }

  .childTopicTextElse img {
    width: 11.245rem;
    height: 7.1rem;
    border-radius: .4rem;
  }

  .childTopicInfo {
    display: flex;
    justify-content: space-between;
  }

  .childTopicTime {
    font-size: 1.2rem;
    color: #999999;
    margin-top: 1.25rem;
  }

  .childTopicData {
    display: flex;
    margin-top: 1.25rem;
    color: #999999;
  }

  .childTopicData div {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
  }

  .childTopicData div p {
    margin-top: .15rem;
  }

  .childTopicData img {
    height: 1.5rem;
    margin-left: 1.5rem;
    margin-right: .4rem;
  }

  .childTopicData p {
    margin-top: -.2rem;
  }

  .topicBtn {
    box-sizing: border-box;
    padding: 0 1.5rem;
    padding-top: 1.3rem;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 7.5rem;
    background-color: #FFF;
    display: flex;
    justify-content: flex-end;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.07);
  }

  .partakeBtnOne {
    position: relative;
    width: 8.5rem;
    height: 3.1rem;
    border-radius: 3.1rem;
    background-color: #F7443F;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    margin-left: 1.25rem;
    color: #FFFFFF;
  }

  .partakeBtn {
    position: relative;
    width: 8.5rem;
    height: 3.1rem;
    border-radius: 3.1rem;
    background-color: #FFE8E7;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    margin-left: 1.25rem;
    color: #F7443F;
  }

  .partakeBtn img {
    width: 1.6rem;
    height: 1.6rem;
    margin-right: .5rem;
  }

  .callAppIcon {
    position: fixed;
    right: 0;
    bottom: 16.5rem;
    z-index: 10;
  }

  .callAppIcon img {
    width: 11.1rem;
    height: 3.35rem;
  }

  .topIcon {
		position: fixed;
		right: 1.1rem;
		bottom: 9rem;
		z-index: 11;
	}

  .topIcon img {
    width: auto;
    height: 4.15rem;
  }
</style>